import {
  AnalyticsOutlined,
  ApartmentOutlined,
  InfoOutlined,
  PhotoLibraryOutlined,
  Logout,
  Newspaper,
  MenuBookOutlined,
  People,
  PeopleOutlineOutlined,
  Reviews,
  Redeem,
  Groups2Outlined,
  EventNoteOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  Drawer,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "reactfire";
import useAdminAccess from "../../hooks/use_admin_access";
import { canAccessModule } from "../../utils/admin_access";

function AdminDrawer() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const auth = useAuth();
  const { allowedModules } = useAdminAccess();

  let dashboardItems = [
    {
      id: 1,
      name: "Dashboard",
      path: "/admin/home",
      module: "dashboard",
      activeIcon: <AnalyticsOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <AnalyticsOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 2,
      name: "About Us",
      path: "/admin/about",
      module: "about",
      activeIcon: <InfoOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <InfoOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 3,
      name: "DEXCO",
      path: "/admin/dexco",
      module: "about",
      activeIcon: <Groups2Outlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <Groups2Outlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 4,
      name: "Users",
      path: "/admin/users",
      module: "users",
      activeIcon: <People sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <PeopleOutlineOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 5,
      name: "News",
      path: "/admin/news",
      module: "news",
      activeIcon: <Newspaper sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <Newspaper sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 6,
      name: "Gallery",
      path: "/admin/gallery",
      module: "gallery",
      activeIcon: <PhotoLibraryOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <PhotoLibraryOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 7,
      name: "Yuvagaaz",
      path: "/admin/yuvagaaz",
      module: "yuvagaaz",
      activeIcon: <MenuBookOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <MenuBookOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 8,
      name: "Deanery",
      path: "/admin/deanery-members",
      module: "deanery",
      activeIcon: <ApartmentOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <ApartmentOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 9,
      name: "Survey",
      path: "/admin/surveys",
      module: "surveys",
      activeIcon: <Reviews sx={{ pl: 1, color: "#ffffff" }} />,
      inActiveicon: <Reviews sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 10,
      name: "REDON",
      path: "/admin/redon",
      module: "redon",
      activeIcon: <Redeem sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <Redeem sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 11,
      name: "YouCat",
      path: "/admin/youcat",
      module: "youcat",
      activeIcon: <MenuBookOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <MenuBookOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 12,
      name: "DYC",
      path: "/admin/dyc",
      module: "dyc",
      activeIcon: <EventNoteOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <EventNoteOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 13,
      name: "Logout",
      path: "",
      activeIcon: <Logout sx={{ pl: 1, color: "#ffffff" }} />,
      inActiveicon: <Logout sx={{ pl: 1, color: "#565564" }} />,
    },
  ];

  return (
    <Box display={"flex"} flexDirection={"column"}>
      {dashboardItems
        .filter((item) => item.name === "Logout" || canAccessModule(allowedModules, item.module as any))
        .map((item) => {
        return (
          <Box
            key={item.id}
            display={"flex"}
            flexDirection={"row"}
            onClick={() => {
              if (item?.name === "Logout") {
                auth?.signOut();
                navigate("/admin/login");
              } else {
                navigate(item?.path);
              }
            }}
            sx={{
              my: 1,
              py: 2,
              pl: 2,
              mr: 2,
              backgroundColor:
                pathname === item?.path ? "#0085DB1F" : "transparent",
              borderTopRightRadius: 10,
              borderBottomRightRadius: 10,
              position: "relative",
              overflow: "hidden",
              ":before": {
                content: '""',
                position: "absolute",
                top: 0,
                right: 0,
                bottom: 0,
                left: "100%",
                backgroundColor: "#0085DB1F",
                transition: "left 0.3s ease-in-out",
                zIndex: 0,
              },
              ":hover:before": {
                left: 0,
              },
              ":hover": {
                border: "0.1px solid #808080",
              },
              justifyContent: "start",
              zIndex: 1,
            }}
          >
            {pathname === item?.path ? item?.activeIcon : item?.inActiveicon}
            <Typography
              textAlign={"start"}
              variant="subtitle2"
              color={pathname === item?.path ? "#0085DB" : "#565564"}
              ml={2}
            >
              {item?.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default AdminDrawer;
